import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { ContactInformationOwnerType } from '@/modules/adjusterReportModules/IncidentParticipants/types/OwnerType';
import { PatchDamagedContactInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedContactInformation/patchDamagedContactInformationQueryFunction';

type MutationVariables = {
  id: string;
  formData: ContactInformationOwnerType;
  damaged_id?: string;
};

export const PatchDamagedContactInformationQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  MutationVariables
> => ({
  mutationKey: ['patch-Damaged-Contact-Information'],
  mutationFn: ({ id, formData, damaged_id }: MutationVariables) =>
    PatchDamagedContactInformationQueryFunction(id, formData, damaged_id),
});
